<p>function-scope works!</p>
